module.exports = require('events').EventEmitter;



// WEBPACK FOOTER //
// ./node_modules/readable-stream/lib/internal/streams/stream-browser.js